import axios from "axios";
import authHeader from "./auth-header";

const API_URL = "https://mail-fetch.onrender.com/api/agent/";
// const API_URL = "https://mail-fetch.onrender.com/api/agent/";


const getAll = () => {
  return axios.get(API_URL, { headers: authHeader() });
};

const create = (data) => {
  return axios.post(API_URL, data, { headers: authHeader() });
};

const update = (id, data) => {
  return axios.put(API_URL + id, data, { headers: authHeader() });
};

const deleteOne = (id) => {
  return axios.delete(API_URL + id, { headers: authHeader() });
};

const agentService = {
    getAll,
    create,
    update,
    deleteOne,
};

export default agentService